import { c as _c } from "react/compiler-runtime";
import { CheckIcon } from '@heroicons/react/16/solid';
import type React from 'react';
import { cn } from '@/app/_lib/utils';
type IconOnTheLeftWithContentLayoutProps = {
  mainContent: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
};
export function IconOnTheLeftWithContentLayout(t0) {
  const $ = _c(14);
  const {
    mainContent,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mt-1 h-4.5 w-4.5 text-algoprimary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <CheckIcon className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== mainContent) {
    t3 = <div className="flex-1">{mainContent}</div>;
    $[4] = mainContent;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-row items-start gap-x-1">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children) {
    t5 = <div>{children}</div>;
    $[9] = children;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex flex-col gap-2">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}